/** Studio: a brand's chat settings (W02, W09, W17, W23, W25). */
export const chatSettingsEn = {
  open: 'Chat settings',
  openLabel: 'Chat settings for {{name}}',
  title: 'Chat settings for {{name}}',
  description:
    'How the chat sits on your website and what customers can do in it. Websites get the changes within a minute.',
  saved: 'Chat settings saved for {{name}}.',
  save: 'Save settings',
  loading: 'Loading the chat settings',
  invalidNumber: 'Enter a whole number from {{min}} to {{max}}.',
  languages: { en: 'English', ar: 'Arabic', hi: 'Hindi', ur: 'Urdu' },
  layout: {
    legend: 'Where the chat appears',
    bubble: 'Floating button',
    bubbleHint: 'A round button in a corner opens the chat.',
    panel: 'Side panel',
    panelHint: 'The button opens the chat along one side of the page.',
    inline: 'In the page',
    inlineHint: 'The chat sits in a part of your page that you choose.',
    fullpage: 'Whole page',
    fullpageHint: 'The chat fills the page, for a help page of its own.',
    side: 'Button corner',
    right: 'Bottom right',
    left: 'Bottom left',
    note: 'On phones, the floating button and the side panel open the chat full screen.',
  },
  files: {
    legend: 'Files',
    enabled: 'Customers can send files',
    enabledHint:
      'Every file is checked for viruses first. Without a virus scanner on the server, the chat offers no files.',
    types: 'Kinds of file',
    png: 'PNG pictures',
    jpeg: 'JPEG photos',
    webp: 'WebP pictures',
    gif: 'GIF pictures',
    pdf: 'PDF documents',
    typesRequired: 'Choose at least one kind of file.',
    maxMegabytes: 'Largest file (MB)',
    maxMegabytesHint: 'From 1 to 10.',
    maxFiles: 'Files in one message',
    maxFilesHint: 'From 1 to 5.',
  },
  help: {
    legend: 'Help before a conversation',
    search: 'Customers can search your public help articles',
    suggestions: 'Suggested questions',
    suggestionsHint:
      'Up to 6, on the chat’s first screen. English is required; an empty language shows the English.',
    question: 'Question {{number}}',
    add: 'Add a question',
    remove: 'Remove question {{number}}',
    required: 'Write question {{number}} in English.',
  },
  deletion: {
    label: 'Customers can delete a message for (minutes)',
    hint: 'From 0 to 60. 0 turns deleting off.',
  },
  emails: {
    label: 'Offer signed-in customers emails about their conversations',
    hint: 'A copy when a conversation closes, and a note when a reply waits. Customers choose, and every email has a link to stop them.',
  },
};
